export default __webpack_public_path__ + "static/media/View-documentation.e050549d.md";